import { type EkycStep } from './types';

export const STEP_BACK_MAP: Partial<Record<EkycStep, EkycStep>> = {
  'terms-and-conditions': 'onboarding',
  'capture-card-consent': 'onboarding',
  'capture-card-instruction': 'capture-card-consent',
  'capture-id-card-front': 'capture-card-instruction',
  'capture-id-card-back': 'capture-id-card-front',
  'id-card-confirmation': 'capture-id-card-back',
  'capture-face-consent': 'onboarding',
  'capture-face-instruction': 'capture-face-consent',
  'capture-face': 'capture-face-instruction',
} as const;

export const DEFAULT_LANGUAGE = 'th';
